// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d8108090","453":"dc3a3811","455":"505e4bac"}[chunkId] + ".chunk.js";
};